import { JQElementHelper } from "../lib/JQElementHelper";
const onOpenEvent = new CustomEvent("show.modal", {
    bubbles: false,
    cancelable: false,
    composed: true
});
const onOpenedEvent = new CustomEvent("shown.modal", {
    bubbles: false,
    cancelable: false,
    composed: true
});
const onHideEvent = new CustomEvent("hide.modal", {
    bubbles: false,
    cancelable: false,
    composed: true
});
const onHiddenEvent = new CustomEvent("hidden.modal", {
    bubbles: false,
    cancelable: false,
    composed: true
});
export class AxModal {
    constructor(jqElementHelper = new JQElementHelper()) {
        this.jqElementHelper = jqElementHelper;
        this.isClickable = true;
        this.closeOnClick = (el) => {
            let $currentModal = el.closest('.ax-modal');
            $currentModal[0].dispatchEvent(onHideEvent);
            $currentModal.trigger('hide.modal', []);
            $currentModal.removeClass("fade-in");
            $currentModal.addClass("fade-out");
            setTimeout(function () {
                $currentModal.removeClass("fade-out");
            }, 600);
            setTimeout(function () {
                $currentModal.removeClass("is-open");
                $currentModal[0].dispatchEvent(onHiddenEvent);
                $currentModal.trigger('hidden.modal', []);
            }, 450);
        };
    }
    init(options) {
        var _a, _b, _c, _d;
        this.trigger = $(((_a = options === null || options === void 0 ? void 0 : options.selector) !== null && _a !== void 0 ? _a : ".ax-modal-trigger"));
        this.closeModal = $((_b = options === null || options === void 0 ? void 0 : options.closeModalSelector) !== null && _b !== void 0 ? _b : ".ax-modal-header-wrapper");
        this.closeModalBtn = $((_c = options === null || options === void 0 ? void 0 : options.closeModalBtnSelector) !== null && _c !== void 0 ? _c : ".js-close-modal");
        this.closeOnBackground = (_d = this.closeOnBackground) !== null && _d !== void 0 ? _d : true;
        this.jqElementHelper.iterateSelector(this.trigger, ($elem) => {
            let modalAttr = $elem.attr('data-target');
            $elem.on("click", (e) => {
                let modalAttr = $(e.delegateTarget).attr('data-target');
                let $modal = $(`.ax-modal[id=${modalAttr}]`);
                this.open($modal[0]);
            });
            $(`.ax-modal[id=${modalAttr}]`).on("click", (e) => {
                const $elem = $(e.delegateTarget);
                const staticBackdrop = $elem.attr('data-backdrop') === 'static';
                if ($(window).width() > 576 && staticBackdrop) {
                    $elem.addClass("bounce");
                    if (!this.isClickable)
                        return false;
                    this.isClickable = false;
                    setTimeout(() => {
                        $('.ax-modal[data-backdrop="static"]').removeClass("bounce");
                        this.isClickable = true;
                    }, 550);
                    $(".ax-modal-content").on("click", (e) => {
                        e.stopPropagation();
                    });
                }
                if (!staticBackdrop && this.closeOnBackground && $(e.target).is($elem)) {
                    this.closeOnClick($elem);
                }
            });
        });
        this.closeModal.on("click", (e) => {
            if ($(window).width() < 576) {
                this.closeOnClick($(e.delegateTarget));
            }
        });
        this.closeModalBtn.on("click", (e) => {
            this.closeOnClick($(e.delegateTarget));
        });
    }
    close(target) {
        this.closeOnClick($(target));
    }
    open(modal) {
        const $modal = $(modal);
        $modal[0].dispatchEvent(onOpenEvent);
        $modal.trigger('show.modal', []);
        $modal.removeClass("fade-out");
        $modal.addClass("fade-in is-open");
        setTimeout(function () {
            $modal.removeClass("fade-in");
            $modal[0].dispatchEvent(onOpenedEvent);
            $modal.trigger('shown.modal', []);
        }, 600);
    }
}
